import type { Camera } from "../api/types";

interface CameraChipProps {
  camera: Camera;
  count: number;
  active: boolean;
  onClick: () => void;
}

export function CameraChip({ camera, count, active, onClick }: CameraChipProps) {
  return (
    <button className={`chip ${active ? "active" : ""}`} onClick={onClick}>
      <span className="dot" />
      {camera.name}
      <span className="count">{count}</span>
    </button>
  );
}

interface AllChipProps {
  active: boolean;
  count: number;
  onClick: () => void;
}

export function AllChip({ active, count, onClick }: AllChipProps) {
  return (
    <button className={`chip ${active ? "active" : ""}`} onClick={onClick}>
      All cameras
      <span className="count">{count}</span>
    </button>
  );
}
